import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ProfileWidget from '../../molecules/ProfileWidget'
import { StyledLogo } from '../../styled/Logo'
import { StyledHeader, StyledVersion } from './styled'
import Search from '../../atoms/Search'
import { Icons } from '../../../types/enums'
import { SelectOption } from '../../../types/html'
import { creditSearch } from '../../../services/utils'

type HeaderProps = {
  logo: {
    src: string
    link: string
  }
  profileWidget: {
    name: string
    avatar: string
    link: string
  }
}

const Header = (props: HeaderProps) => {
  const navigate = useNavigate()
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchResults, setSearchResults] = useState<SelectOption[]>([])

  const handleSearch = async (value: string) => {
    if (!value || value.length < 3) {
      setSearchResults([])
      return
    }
    setSearchLoading(true)
    try {
      const results = await creditSearch(value)
      const options: SelectOption[] = results.map(
        (credit: { code: number; client: { name: string }; bank: { name: string } }) => ({
          value: credit.code.toString(),
          label: `${credit.code} - ${credit.client.name} - ${credit.bank.name}`,
        })
      )
      setSearchResults(options)
    } catch {
      setSearchResults([])
    } finally {
      setSearchLoading(false)
    }
  }

  const handleSelect = (option: SelectOption) => {
    navigate(`/credito/${option.value}`)
  }

  return (
    <StyledHeader>
      <Link to={props.logo.link}>
        <StyledLogo src={props.logo.src} />
        <StyledVersion>Version 1.2.1</StyledVersion>
      </Link>
      <Search
        placeholder="Buscar cliente..."
        preIcon={Icons.SEARCH}
        loading={searchLoading}
        results={searchResults}
        onChange={handleSearch}
        onSelect={handleSelect}
      />
      <ProfileWidget
        avatar={props.profileWidget.avatar}
        name={props.profileWidget.name}
        link={props.profileWidget.link}
      />
    </StyledHeader>
  )
}

export default Header
